import * as React from 'react'
import { useEffect, useState } from 'react'
import { v4 } from 'uuid'
import { FormattedMessage } from 'react-intl'

import { Button, Icon, Text } from '@metrisk/react_metrisk-components'

import PurchaseItem from './PurchaseItem'

import './PurchaseItems.scss'
import campaign from '@app/config/campaign'

const fields: any = {
  productId: {
    valid: false,
    value: null,
  },
  model: {
    valid: false,
    value: null,
  },
  purchasePrice: {
    valid: false,
    value: null,
  },
  quantity: {
    valid: true,
    value: 1,
  },
  urn: {
    valid: false,
    value: null,
  }
}

const PurchaseItems = ({ fieldsToRender, formFields, onChange }: any) => {
  const [items, setItems] = useState([])

  useEffect(() => {
    const items = [generateNewRow()]
    setItems(items)
    onChange(items)
  }, [])

  const getFieldsToRender = () => {
    const validFields = Object.keys(fields).reduce((render, field) => {
      if (fieldsToRender.includes(field)) return {
        ...render,
        [field]: {
          ...fields[field],
        }
      }

      return render
    }, {})

    return validFields
  }

  const generateNewRow = (): any => {
    return {
      id: v4(),
      valid: false,
      fields: getFieldsToRender(),
    }
  }

  const handleAddNewRow = () => {
    if (items.length < 4) {
      const updatedItems = [...items, generateNewRow()]
      setItems(updatedItems)
      onChange(updatedItems)
    }
  }

  const handleDeleteRow = (id: string) => {
    if (items.length > 1) {
      const updatedItems = items.filter((item) => item.id !== id)
      setItems(updatedItems)
      onChange(updatedItems)
    }
  }

  const handleItemUpdate = (id: string, field: string, value: any, valid: boolean) => {
    const updatedItems = items.map((item: any) => {
      if (item.id === id) {
        const fields = {
          ...item.fields,
          [field]: {
            valid,
            value,
          },
        }

        return {
          id,
          valid: Object.keys(fields).every((field: any) => fields[field].valid),
          fields,
        }
      }

      return item
    })

    setItems(updatedItems)
    onChange(updatedItems)
  }

  return (
    <div>
      <Text type={'Delta'}><FormattedMessage defaultMessage='Qualifying Products Purchased'/></Text>
      <Text><FormattedMessage defaultMessage='Please add details of the qualifying products you purchased on the receipt below.'/></Text>

      {items.map((item, index) => (
        <PurchaseItem
          key={item.id}
          index={index}
          item={item}
          formFields={formFields}
          canDelete={items.length > 1}
          onItemUpdate={handleItemUpdate}
          onDelete={handleDeleteRow}
        />
      ))}

      {items.length < 4 && campaign.maxRedemptions !== 1 && (
        <div className="purchase-information__footer">
          <Button type={'Secondary'} onClick={handleAddNewRow}>
            <Icon name={'Plus'} />
          </Button>
        </div>
      )}
    </div>
  )
}

export default PurchaseItems
